import React, { useState } from 'react';
import {
  Table, Card, Button, Typography, Tag, Row, Col,
  Input, Checkbox, Space, Alert, Avatar
} from 'antd';
import {
  UserAddOutlined, EditOutlined, SaveOutlined,
  ArrowLeftOutlined, MailOutlined, SafetyCertificateOutlined,
  UserOutlined, KeyOutlined
} from '@ant-design/icons';
import LayoutHome from '../../components/layout/LayoutHome';

const { Title, Text } = Typography;

const Usuarios = () => {
  // ESTADOS: 'lista' o 'edicion'
  const [vista, setVista] = useState('lista');
  const [usuarioSeleccionado, setUsuarioSeleccionado] = useState(null);

  // Datos de ejemplo (Vendrían de Cognito/DB)
  const [usuarios] = useState([
    { id: '1', nombre: 'Admin Yugonub', email: 'admin@yugonub.com', rol: 'ADMIN', estado: 'Activo' },
    { id: '2', nombre: 'Juan Cajero', email: 'juan@ventas.com', rol: 'CAJERO', estado: 'Activo' },
  ]);

  // MATRIZ DE PERMISOS (Estructura lógica)
  const modulosPermisos = [
    { key: 'ventas', label: 'Ventas (Facturación)', icon: <SafetyCertificateOutlined /> },
    { key: 'caja', label: 'Cierre de Caja y Arqueo', icon: <SafetyCertificateOutlined /> },
    { key: 'productos', label: 'Gestión de Productos', icon: <SafetyCertificateOutlined /> },
    { key: 'gastos', label: 'Registro de Gastos', icon: <SafetyCertificateOutlined /> },
    { key: 'informes', label: 'Informes y Estadísticas', icon: <SafetyCertificateOutlined /> },
    { key: 'usuarios', label: 'Gestión de Usuarios', icon: <SafetyCertificateOutlined /> },
  ];

  const columnas = [
    {
      title: 'Usuario',
      dataIndex: 'nombre',
      render: (text, record) => (
        <Space>
          <Avatar style={{ backgroundColor: '#22BABB' }}>{text[0]}</Avatar>
          <div>
            <Text strong>{text}</Text><br />
            <Text type="secondary" style={{ fontSize: '12px' }}>{record.email}</Text>
          </div>
        </Space>
      ),
    },
    {
      title: 'Rol',
      dataIndex: 'rol',
      render: (rol) => <Tag color={rol === 'ADMIN' ? 'gold' : 'blue'}>{rol}</Tag>,
    },
    {
      title: 'Acciones',
      render: (_, record) => (
        <Button type="text" icon={<EditOutlined />} onClick={() => handleEditar(record)}>
          Editar Permisos
        </Button>
      ),
    },
  ];

  const handleEditar = (usuario) => {
    setUsuarioSeleccionado(usuario);
    setVista('edicion');
  };

  // --- VISTA DE LISTA ---
  const VistaLista = () => (
    <Card bordered={false} className="card-shadow">
      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 20 }}>
        <Title level={4}>Usuarios del Sistema</Title>
        <Button
          type="primary"
          icon={<UserAddOutlined />}
          style={{ backgroundColor: '#22BABB' }}
          onClick={() => { setUsuarioSeleccionado(null); setVista('edicion'); }}
        >
          Nuevo Usuario
        </Button>
      </div>
      <Table columns={columnas} dataSource={usuarios} rowKey="id" />
    </Card>
  );

  // --- VISTA DE EDICIÓN / DETALLE ---
  const VistaEdicion = () => (
    <Card bordered={false} className="card-shadow">
      <Button type="link" icon={<ArrowLeftOutlined />} onClick={() => setVista('lista')} style={{ marginBottom: 20 }}>
        Volver a la lista
      </Button>

      <Row gutter={[32, 32]}>
        {/* COLUMNA IZQUIERDA: DATOS */}
        <Col xs={24} md={10}>
          <Title level={4}>{usuarioSeleccionado ? 'Editar Usuario' : 'Crear Usuario'}</Title>
          <Space direction="vertical" style={{ width: '100%' }} size="large">
            <div>
              <Text type="secondary">Nombre Completo</Text>
              <Input prefix={<UserOutlined />} allowClear placeholder="Ej: Carlos Pérez" defaultValue={usuarioSeleccionado?.nombre} />
            </div>
            <div>
              <Text type="secondary">Correo Electrónico (Cognito ID)</Text>
              <Input prefix={<MailOutlined />} allowClear placeholder="correo@empresa.com" defaultValue={usuarioSeleccionado?.email} disabled={!!usuarioSeleccionado} />
            </div>
            <Alert
              message="Seguridad"
              description="Al crear un usuario, recibirá un correo de Yugonub para configurar su contraseña."
              type="info"
              showIcon
            />
          </Space>
        </Col>

        {/* COLUMNA DERECHA: PERMISOS */}
        <Col xs={24} md={14} style={{ borderLeft: '1px solid #f0f0f0' }}>
          <Title level={4}><KeyOutlined /> Permisos de Acceso</Title>
          <Text type="secondary">Selecciona a qué módulos tendrá acceso este usuario:</Text>

          <div style={{ marginTop: 20, padding: '20px', background: '#f8fafc', borderRadius: '12px' }}>
            <Row gutter={[16, 16]}>
              {modulosPermisos.map(modulo => (
                <Col span={12} key={modulo.key}>
                  <Checkbox defaultChecked={usuarioSeleccionado?.rol === 'ADMIN'}>
                    <Text strong>{modulo.label}</Text>
                  </Checkbox>
                </Col>
              ))}
            </Row>
          </div>

          <div style={{ marginTop: 30, textAlign: 'right' }}>
            <Button size="large" style={{ marginRight: 10 }}>Cancelar</Button>
            <Button
              type="primary"
              size="large"
              icon={<SaveOutlined />}
              style={{ backgroundColor: '#22BABB' }}
              onClick={() => setVista('lista')}
            >
              Guardar Cambios
            </Button>
          </div>
        </Col>
      </Row>
    </Card>
  );

  return (
    <LayoutHome pageSeleccionada="usuarios">
      <div style={{ padding: '24px' }}>
        {/* HEADER DEL MODULO */}
        <div style={{ marginBottom: 24 }}>
          <Title level={3} style={{ color: '#22BABB', margin: 0 }}>Gestión de Usuarios</Title>
          <Text type="secondary">Administra quién puede acceder y qué puede hacer en tu negocio.</Text>
        </div>

        {vista === 'lista' ? <VistaLista /> : <VistaEdicion />}
      </div>
    </LayoutHome>
  );
};

export default Usuarios;